import React from 'react'
// import Toggle from 'react-toggle'
import { Link } from 'react-router-dom'
import BulkCoupon from './BulkCoupon'
import CouponLists from './CouponList'

class CouponController extends React.Component {
  state = {
    type: 'new',
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          {
            localStorage.getItem('user_role') !== 'ops-coord' &&
            <div
              className="page-header"
              style={{ borderBottom: '1px solid #ddd', paddingBottom: 10 }}
            >
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h5 style={{ display: 'flex' }}>
                        Create Coupon
                        {/* <div style={{ alignContent: 'center' }}>
                        <span
                          style={{ display: 'inline-flex', alignItems: 'center', fontSize: 12 }}
                          className="m-l-20 mt-0"
                        >
                          OLD{' '}
                          <Toggle
                            className="m-l-10 m-r-10 custom-classname"
                            id={'coupon-type'}
                            checked={this.state.type === 'new' ? true : false}
                            icons={null}
                            onChange={() => {
                              this.setState({
                                type: this.state.type == 'new' ? 'old' : 'new',
                              })
                            }}
                          ></Toggle>{' '}
                          NEW
                        </span>
                      </div> */}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/coupon-controller`}>Coupons</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          }
          {this.state.type == 'new' ? <BulkCoupon></BulkCoupon> : <CouponLists></CouponLists>}
        </div>
      </div>
    )
  }
}

export default CouponController
